<template>
<section class="home">
<Storagestatus />
    <folder />
    <!-- <createUpload /> -->
    <!-- <footer /> -->
    <!-- add popup -->
   <!-- <criclebar /> -->

  </section>
</template>
  <script>
  
  // import criclebar from "../components/criclebar"
  import Storagestatus from "../components/Storagestatus"
  // import fileoption from "../components/fileoption"
  import folder from "../components/folder"
  import "../js/loading-bar.js"
  // import "../js/custom"
export default {
  name: "Home",
  components: {
    folder,
    Storagestatus,
    
  },
  
}
</script>